import useTranslation from "~/kernel/internationalization/useTranslation";

type LogoIconProps = {
  className?: string;
};

export default function LogoIcon({ className = "w-10" }: LogoIconProps) {
  const { t } = useTranslation();
  return (
    <img
      className={className}
      src="/logo-icon.svg"
      width="671"
      height="681"
      alt={t("common.logoAlt")}
    />
  );
}
